'use strict'
module.exports = require('./lib/api')(require('./lib/keccak'))



//////////////////
// WEBPACK FOOTER
// ./~/keccak/js.js
// module id = 1236
// module chunks = 0